import { render, staticRenderFns } from "./BtnInserirDetalheEntrega.vue?vue&type=template&id=5807e976"
import script from "./BtnInserirDetalheEntrega.vue?vue&type=script&lang=js"
export * from "./BtnInserirDetalheEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports